'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const LockUnlockedIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="LockUnlockedIcon">
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        id="Lock-Unlock-4--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>Lock Unlock 4 Streamline Icon: https://streamlinehq.com</desc>
        <path
          d="M10 16.03a2 2 0 1 0 4 0 2 2 0 1 0 -4 0Z"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M20.5 13.53a4 4 0 0 0 -4 -4h-9a4 4 0 0 0 -4 4v6a4 4 0 0 0 4 4h9a4 4 0 0 0 4 -4Z"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M6.5 6.03a5.5 5.5 0 0 1 11 0v3.626"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

LockUnlockedIcon.propTypes = {
  sx: PropTypes.object
}
